import { ClientPropertyTypeEnum } from "web_myplann/Infrastructure/Api/Api";

export type RealEstateType =
	| ClientPropertyTypeEnum.Land
	| ClientPropertyTypeEnum.Flat
	| ClientPropertyTypeEnum.House
	| ClientPropertyTypeEnum.Cottage;

export type BuildingRealEstateType =
	| ClientPropertyTypeEnum.Flat
	| ClientPropertyTypeEnum.House
	| ClientPropertyTypeEnum.Cottage;

export const REAL_ESTATE_TYPES: RealEstateType[] = [
	ClientPropertyTypeEnum.Flat,
	ClientPropertyTypeEnum.House,
	ClientPropertyTypeEnum.Cottage,
	ClientPropertyTypeEnum.Land,
];

export const DEFAULT_REAL_ESTATE_TYPE: RealEstateType =
	ClientPropertyTypeEnum.Flat;

export const isRealEstateType = (
	type: ClientPropertyTypeEnum,
): type is RealEstateType =>
	type === ClientPropertyTypeEnum.Land ||
	type === ClientPropertyTypeEnum.Flat ||
	type === ClientPropertyTypeEnum.House ||
	type === ClientPropertyTypeEnum.Cottage;
